module.exports = __webpack_public_path__ + "static/media/now_live.585cee24.svg";